(function (window) {
  const displayLabel = (value) => {
    const raw = String(value ?? '').trim();
    if (!raw) return '';

    return raw
      .split(' / ')
      .map((segment) => {
        const trimmed = segment.trim();
        if (!trimmed.includes(':')) return trimmed;
        return trimmed.slice(trimmed.lastIndexOf(':') + 1).trim() || trimmed;
      })
      .join(' / ');
  };

  const swatchFileHandle = (value) =>
    String(value ?? '')
      .replace(/:/g, '-')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  window.variantOptionDisplayLabel = displayLabel;
  window.variantOptionSwatchHandle = swatchFileHandle;
})(window);
